import { render, staticRenderFns } from "./kesehatanrohani_detail.vue?vue&type=template&id=fccc0a6e&"
import script from "./kesehatanrohani_detail.vue?vue&type=script&lang=js&"
export * from "./kesehatanrohani_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports